import React from 'react';
import { Control } from 'react-hook-form';
import { FormTextarea } from '../components/shared/FormTextarea';
import { TagInput } from '../components/shared/TagInput';
import { OnboardingData } from '../types';

interface Step2BrandIdentityProps {
  control: Control<OnboardingData>;
}

const Step2BrandIdentity: React.FC<Step2BrandIdentityProps> = ({
  control
}) => {
  return (
    <div className="space-y-6">
      {/* Question 1: Business purpose */}
      <div>
        <FormTextarea
          name="step2_brandIdentity.businessPurpose"
          control={control}
          label="Tell me about your business. What purpose do you serve?"
          placeholder="Describe your business mission and the purpose you serve for your customers..."
          rows={2}
          rules={{ required: 'This field is required' }}
        />
      </div>

      {/* Question 2: Brand passion */}
      <div>
        <FormTextarea
          name="step2_brandIdentity.brandPassion"
          control={control}
          label="What makes you passionate about your brand?"
          placeholder="Share what drives you and what you love about your brand..."
          rows={2}
          rules={{ required: 'This field is required' }}
        />
      </div>

      {/* Question 3: Brand keywords */}
      <div>
        <label className="block text-sm text-text font-medium mb-3">
          List 5–10 words that come to mind when you think about your brand.
        </label>
        <TagInput
          name="step2_brandIdentity.brandKeywords"
          control={control}
          placeholder="Add brand keyword... (press Enter or comma)"
          rules={{
            validate: (value: string[]) => {
              if (!value || value.length < 5) {
                return 'Please add at least 5 brand keywords';
              }
              if (value.length > 10) {
                return 'Please add no more than 10 brand keywords';
              }
              return true;
            }
          }}
        />
      </div>
    </div>
  );
};

export { Step2BrandIdentity };